module.exports = __webpack_public_path__ + "static/assets/b30515f8d38506f6fdb5e9579f502556.png";